// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from './Typography';
import Card from './Card';

type Props = {
  name: string,
  number: string
}

const HelpYourself = ({ name, number }: Props) => {
  const { t } = useTranslation('helpYourself');
  return (
    <Card noShadow noBorder className='help-yourself'>
      <Text paragraph bold className='help-yourself__title'>{t('speed_up')}</Text>
      <div className='help-yourself__content'>
        <Text link href={`tel:${number}`} className='help-yourself__link help-yourself__subtitle'>
          {t('call_name_at_number', { name, number })}
        </Text>
        <Text paragraph>
          {t('let_them_know_waiting')}
        </Text>
      </div>
    </Card>
  );
};

export default HelpYourself;



// WEBPACK FOOTER //
// ./src/components/shared/HelpYourself.js